export const META_PIXEL_ID = '761617479540023'

type Fbq = (...args: unknown[]) => void

declare global {
  interface Window {
    fbq?: Fbq & { callMethod?: Fbq; queue?: unknown[]; loaded?: boolean; version?: string }
    _fbq?: unknown
  }
}

/** Carga el script del Meta Pixel una sola vez y dispara el PageView inicial. */
export function loadMetaPixel(): void {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq && fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq?.queue?.push(args)
      }
    } as Window['fbq']

    if (!fbq) return
    window.fbq = fbq
    window._fbq = fbq
    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const pixelImage = document.createElement('img')
    pixelImage.height = 1
    pixelImage.width = 1
    pixelImage.style.display = 'none'
    pixelImage.alt = ''
    pixelImage.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(pixelImage)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Dispara un evento estándar del pixel (por ejemplo InitiateCheckout). */
export function trackMetaPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}
